import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";

const COOKIE_NAME = "duro_top_announcement_tilia_dismissed";
const COOKIE_EXPIRES_IN_DAYS = 7;

const TopAnnouncementBar = () => {
  const { t } = useTranslation();
  const barRef = useRef(null);
  const [isVisible, setIsVisible] = useState(() => !Cookies.get(COOKIE_NAME));

  useEffect(() => {
    const { body } = document;

    if (!body) {
      return undefined;
    }

    if (isVisible) {
      body.classList.add("top-announcement-visible");
    } else {
      body.classList.remove("top-announcement-visible");
      body.style.removeProperty("--top-announcement-height");
    }

    return () => {
      body.classList.remove("top-announcement-visible");
      body.style.removeProperty("--top-announcement-height");
    };
  }, [isVisible]);

  useEffect(() => {
    const { body } = document;
    const bar = barRef.current;

    if (!isVisible || !body || !bar) {
      return undefined;
    }

    const updateAnnouncementHeight = () => {
      body.style.setProperty(
        "--top-announcement-height",
        `${bar.getBoundingClientRect().height}px`
      );
    };

    updateAnnouncementHeight();

    if (typeof ResizeObserver === "undefined") {
      window.addEventListener("resize", updateAnnouncementHeight);

      return () => {
        window.removeEventListener("resize", updateAnnouncementHeight);
      };
    }

    const resizeObserver = new ResizeObserver(updateAnnouncementHeight);
    resizeObserver.observe(bar);

    return () => {
      resizeObserver.disconnect();
    };
  }, [isVisible, t]);

  const handleClose = () => {
    Cookies.set(COOKIE_NAME, "true", {
      expires: COOKIE_EXPIRES_IN_DAYS,
      path: "/",
    });
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  const linkUrl = t("topAnnouncement.linkUrl");
  const linkText = t("topAnnouncement.linkText");

  return (
    <div className="top-announcement-bar" ref={barRef}>
      <div className="top-announcement-content">
        <p className="top-announcement-message">
          {t("topAnnouncement.message")}
        </p>
        <a
          className="top-announcement-link"
          href={linkUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          {linkText}
        </a>
      </div>
      <button
        type="button"
        className="top-announcement-close"
        onClick={handleClose}
        aria-label={t("topAnnouncement.closeLabel")}
      >
        &times;
      </button>
    </div>
  );
};

export default TopAnnouncementBar;
